import React from 'react';
import ReactSelect from 'react-select';
import { useMediaQuery, useTheme } from '@material-ui/core';

const Select = props => {
  const { style } = props;
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('sm'));
  return (
    <ReactSelect
      components={{ IndicatorSeparator: null }}
      styles={{
        container: (provided, state) => ({
          ...provided,
          marginTop: 24,
          width: '100%',
          maxWidth: 468,
          ...style,
        }),
        input: (provided, state) => ({
          ...provided,
          display: 'flex',
          alignItems: 'center',
          fontSize: 20,
        }),
        control: (provided, state) => ({
          ...provided,
          borderRadius: isDesktop ? 50 : 4,
          height: 50,
        }),
        placeholder: (provided, state) => ({
          ...provided,
          fontSize: 20,
          fontFamily: 'Lato',
          color: '#B3B3B3',
        }),
        singleValue: (provided, state) => ({
          ...provided,
          fontSize: 20,
          fontFamily: 'Lato',
        }),
        valueContainer: (provided, state) => ({
          ...provided,
          padding: '2px 24px',
        }),
      }}
      {...props}
    />
  );
};

export default Select;
